// BookTourForm.jsx
import React, { useState } from "react";
import "./booktour.css";
import { FaUser, FaEnvelope, FaPhone, FaTrash } from "react-icons/fa";
import Header from "../../components/Navbar";
import axios from "axios";
import Swal from "sweetalert2";

export default function BookTourForm() {
  const [contactMethod, setContactMethod] = useState("email");
  const [wantsShowing, setWantsShowing] = useState(true);
  const [dateTimes, setDateTimes] = useState([{ date: "", time: "" }]);

  const [selectedPlans, setSelectedPlans] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSelectPlan = (value) => {
    setSelectedPlans((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleToggleShowing = (e) => {
    const checked = e.target.checked;
    setWantsShowing(checked);
    if (!checked) setDateTimes([]);
    else setDateTimes((prev) => (prev.length ? prev : [{ date: "", time: "" }]));
  };

  const addDateTime = () => {
    setDateTimes((prev) => {
      if (prev.length >= 3) return prev;
      return [...prev, { date: "", time: "" }];
    });
  };

  const removeDateTime = (index) => {
    setDateTimes((prev) => {
      const copy = [...prev];
      copy.splice(index, 1);
      return copy.length ? copy : [{ date: "", time: "" }];
    });
  };

  const updateDateTime = (index, field, value) => {
    setDateTimes((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // prepare payload exactly as required
    const payload = {
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      message: formData.message,
      propaertyId: "33", // static for now
      preferance: ["I am currently working with a REALTOR"],
      phonenumber: formData.phone,
      contactMethod: contactMethod.toLowerCase(),
      planToNextFewMonth: selectedPlans.length
        ? selectedPlans
        : ["Plan to next 6 month!"],
      visitDate: dateTimes.map((d) =>
        d.date ? d.date.split("-").reverse().join("-") : ""
      ), // convert 2025-12-12 → 12-12-2025
      visitTime: dateTimes.map((d) => d.time || "Any Time"),
    };

    console.log("Sending payload:", payload);

   try {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const response = await axios.post(`${baseURL}/toure/add`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  console.log("API Response:", response.data);

  // ✅ Success alert
  Swal.fire({
    title: "Success!",
    text: "Tour request submitted successfully!",
    icon: "success",
    confirmButtonText: "OK",
  });
} catch (error) {
  console.error("API Error:", error);

  // ❌ Error alert
  Swal.fire({
    title: "Error!",
    text: "Something went wrong while submitting the tour form!",
    icon: "error",
    confirmButtonText: "Try Again",
  });
}
  };

  return (
    <>
      <Header />
      <div className="booktour-container">
        <form className="form-card" onSubmit={handleSubmit}>
          <h2 className="form-title">Book Your Free Tour</h2>
          <p className="form-subtitle">Schedule your private tour today.</p>

          <div className="form-row">
            <div className="input-wrapper">
              <FaUser className="icon" />
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div className="input-wrapper">
              <FaUser className="icon" />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="label-title">Preferred Method of Contact</label>
            <div className="radio-group">
              {["Email", "Phone", "Text"].map((method) => (
                <label key={method} className="radio-label">
                  <input
                    type="radio"
                    name="contactMethod"
                    value={method}
                    checked={contactMethod === method.toLowerCase()}
                    onChange={(e) =>
                      setContactMethod(e.target.value.toLowerCase())
                    }
                  />
                  {method}
                </label>
              ))}
            </div>
          </div>

          <div className="input-wrapper">
            <FaEnvelope className="icon" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-wrapper">
            <FaPhone className="icon" />
            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-wrapper">
            <FaUser className="icon" />
            <input
              type="text"
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleInputChange}
            />
          </div>

          {/* ✅ Multi-select dropdown */}
          <label className="label-title">
            In the next 6 months do you plan to:
          </label>

          <div className="custom-multi-select">
            <div
              className="selected-display"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {selectedPlans.length === 0
                ? "0 Selected"
                : `${selectedPlans.length} Selected`}
            </div>

            {showDropdown && (
              <div className="dropdown-options">
                {[
                  "Buy First Home",
                  "Sell a Home",
                  "Buy Again",
                  "Rent a Home",
                  "Invest in a property",
                  "Browse Listing",
                  "Track Market Trends",
                ].map((option) => (
                  <label key={option} className="option-item">
                    <input
                      type="checkbox"
                      value={option}
                      checked={selectedPlans.includes(option)}
                      onChange={(e) => handleSelectPlan(e.target.value)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            )}
          </div>

          <label className="label-title">
            Information to help the Twoffers Respond:
          </label>

          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={wantsShowing}
                onChange={handleToggleShowing}
              />
              I wish to book a showing. Choose up to 3 date and time
              combinations.
            </label>
          </div>

          {wantsShowing && (
            <div className="date-times-wrapper">
              {dateTimes.map((dt, idx) => (
                <div key={idx} className="date-time-row">
                  <div className="input-inline">
                    <input
                      type="date"
                      value={dt.date}
                      onChange={(e) =>
                        updateDateTime(idx, "date", e.target.value)
                      }
                      className="input-date"
                    />
                  </div>

                  <div className="input-inline">
                    <select
                      className="dropdown"
                      value={dt.time}
                      onChange={(e) =>
                        updateDateTime(idx, "time", e.target.value)
                      }
                    >
                      <option value="">Any Time</option>
                      <option>Morning</option>
                      <option>Afternoon</option>
                      <option>Evening</option>
                    </select>
                  </div>

                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removeDateTime(idx)}
                    title="Remove"
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}

              <div className="date-time-controls">
                <button
                  type="button"
                  className="plus-btn"
                  onClick={addDateTime}
                  disabled={dateTimes.length >= 3}
                >
                  +
                </button>
                <span className="hint">{dateTimes.length}/3 selected</span>
              </div>
            </div>
          )}

          <div className="checkbox-group">
            <label className="checkbox-label">
              <input type="checkbox" />I am currently working with a Twoffers.
            </label>
            <label className="checkbox-label">
              <input type="checkbox" />I have been pre-approved for a mortgage.
            </label>
            <label className="checkbox-label">
              <input type="checkbox" />I wish to give my location, if available.
            </label>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}
